module.exports = __webpack_public_path__ + "media/3_1.b4f10dc3.mp4";